import {SuperobjectName} from './superobject-name';
import {SuperObjectDescription} from './super-object-description';
import {BaseModel} from './base-model';

export class SearchConcepts {
  hits: number;
  concepts: Array<ConceptListItem>;
  facets: Array<any>;
}

export class ConceptListItem {
  $$deleted = false;
  $$selected = false;

  artifact_id = '';
  artifact_name = '';
  authority_id = null;
  authority_id_value = '';
  authority_dataset_id_value = '';
  children: Array<ConceptListItem>;
  code = '';
  description = '';
  filters: any;
  has_authority = false;
  is_leaf: boolean;
  is_parent: boolean;
  parent_path = '';
  level = 0;
  meta_type = '';
  name = '';
  valid = true;
  object_type: string;
  open = false;
  parent_id = '';
  parent_id_value: string;
  superobject_type_id: string;
  updated_at: string;
  updated_by_id: string;
  updated_by_id_value: string;
}

export class Concept extends BaseModel {
  authority_id = null;
  authority_id_value = '';
  authority_dataset_id_value = '';
  code = '';
  description: SuperObjectDescription;
  valid = true;
  name: SuperobjectName;
  updated_by_id = null;
  updated_by_id_value = null;

  // Non-server properties
  edit: boolean;
}

export class ConceptHierarchic extends Concept {
  children: Array<ConceptListItem>;
  is_leaf = true;
  level = 0;
  parent_id: string;
  parent_id_value: string;
  parent_path: string;
}

export enum SortDir {
  Asc = 'asc',
  Desc = 'desc'
}

export class ConceptsParams {
  concept_type_id: string;
  meta_type: string;
  is_leaf: boolean;
  valid: boolean;
  parent_id: string;
  query: string;
  rows: number;
  start: number;
  sort: string;
  sort_dir: SortDir;
}
